import React, { useState } from 'react'
import {
    TreeView,
    TreeNode,
} from '@carbon/react';
import { IFileQueuerLocation, IFileQueuerLocationContent } from './FileQueuer.model';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { selectFileQueuerContent, setSelectedFileQueuerPath } from '../../../AppSlice';

interface ITreeNodeItem {
    id: string;
    label: string;
    isExpanded?: boolean;
    style?: React.CSSProperties;
    onClick?: () => void;
}

interface IProps {
    item: ITreeNodeItem;
    path: string;
    selected: string[];
}

function FQTreeNode({ item, path, selected }: IProps) {

    const dispatch = useAppDispatch()
    const children = useAppSelector(selectFileQueuerContent)[item.id] || [];
    const onSelect = () => {
        dispatch(setSelectedFileQueuerPath(item.id))
    }

    return (<TreeNode
        id={item.id}
        label={`${item.label}`}
        selected={selected}
        isExpanded={true}
        style={item.style}
        onSelect={() => onSelect()}
        onClick={() => onSelect()}
    >
        {children
            ?.filter(child => child.isDirectory)
            .map((child) => (
                <FQTreeNode
                    key={path + child.relativePath}
                    item={{
                        id: child.relativePath,
                        label: child.name,
                        isExpanded: true,
                    }}
                    selected={selected}
                    path={child.relativePath} />
            ))}
    </TreeNode>
    )
}
interface ITreeProps {
    selectedPath: string;
    selectedLocation: string;
    locations: IFileQueuerLocation[]
    content: IFileQueuerLocationContent[]
    onSelect: Function;
}

export function FQTree({ selectedLocation, selectedPath, content, locations, onSelect }: ITreeProps) {
    // const [selectedTreeNode, setSelectedTreeNode] = useState<string | null>(null);

    return <TreeView
        label=""
        key={"tree" + selectedLocation + selectedPath}
        selected={[selectedLocation]}
        onSelect={(e) => onSelect(e.currentTarget.nodeValue)}
    >
        <TreeNode key={"rootnode" + selectedLocation + selectedPath} id={selectedLocation} defaultIsExpanded={true} label={selectedLocation === null ? "Select a resource" : locations.find(l => l.id === selectedLocation)?.label} isExpanded={true} style={{ cursor: "pointer" }}>
            {content?.filter(files => files.isDirectory)
                .map(file => (
                    <FQTreeNode
                        key={selectedLocation + selectedPath + file.name}
                        selected={[selectedPath]}
                        path={file.relativePath}
                        item={{
                            id: file.relativePath,
                            label: file.name,
                            isExpanded: true,
                        }}
                    />
                ))
            }
        </TreeNode>
    </TreeView>
}

export default FQTree
